import { Seo } from '~/components/Seo'
import { PageLayout } from '~/lib/components/layouts/PageLayout'
import { CTASection } from './components/CTASection'
import { FAQSection } from './components/FAQSection'
import { FeaturesSection } from './components/FeaturesSection'
import { HeroSection } from './components/HeroSection'
import { ProblemSection } from './components/ProblemSection'
import { ResultsSection } from './components/ResultsSection'
import { ROISection } from './components/ROISection'
import { TrustSignals } from './components/TrustSignals'
import { ValidationSection } from './components/ValidationSection'

/**
 * Structured data for the home page.
 *
 * Deliberately says nothing it cannot back: no aggregateRating, because there
 * are no reviews yet, and no offers block, because inventing a price in machine
 * readable form is the same lie as inventing one in prose. Both can be added
 * the day they are true.
 */
const ORGANIZATION = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SOTA Navigator',
  url: 'https://sotanavigator.com',
  description: 'Literature review software for medical device clinical evaluation under EU MDR.',
  founder: [
    { '@type': 'Person', name: 'Hatem Rabeh' },
    { '@type': 'Person', name: 'François Girinon' },
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: 'admin@sotanavigator.com',
  },
}

const SOFTWARE = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'SOTA Navigator',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description:
    'Runs the literature review behind a medical device clinical evaluation: searches, screening, appraisal, extraction and PRISMA reporting.',
  url: 'https://sotanavigator.com',
}

const Index = () => {
  return (
    <>
      <Seo
        title="Literature Review Software for Medical Device Clinical Evaluation | SOTA Navigator"
        description="Run the literature review behind a clinical evaluation in one place: searches, screening, appraisal and PRISMA counts that stay reconcilable from first query to final table."
        jsonLd={[ORGANIZATION, SOFTWARE]}
      />
      <PageLayout>
        <main className="min-h-screen">
          <HeroSection />
          <TrustSignals />
          <ProblemSection />
          <ResultsSection />
          <FeaturesSection />
          <ValidationSection />
          <ROISection />
          <FAQSection />
          <CTASection />
        </main>
      </PageLayout>
    </>
  )
}

export default Index
